import { useQuery } from "@tanstack/react-query";
import { listIngestAlerts } from "../api/ingestAlerts";
import { ApiError } from "../api/client";

const INGEST_ALERTS_QUERY_KEY = ["tawa", "ingest-alerts"];

// Relu à chaque retour sur l'onglet, même frais : l'utilisateur revient du
// terminal où il vient de renvoyer ses journées. Un 404 signifie que l'API
// n'est pas encore déployée : inutile d'insister.
export function useIngestAlerts() {
  return useQuery({
    queryKey: INGEST_ALERTS_QUERY_KEY,
    queryFn: listIngestAlerts,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: "always",
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.status === 404) &&
      failureCount < 1,
  });
}
